import { render, staticRenderFns } from "./CustomerPreviousSales.vue?vue&type=template&id=e2750596&scoped=true&"
import script from "./CustomerPreviousSales.vue?vue&type=script&lang=js&"
export * from "./CustomerPreviousSales.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPreviousSales.vue?vue&type=style&index=0&id=e2750596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2750596",
  null
  
)

export default component.exports